import UploadFileType from "./enums/UploadFileType";
import UploadFileStatus from "./enums/UploadFileStatus";

class UploadFileInformation {
  public uniqueID: number;
  public identifier: string;
  public uploadFileType: UploadFileType;
  public file: File;
  public uploadID: number = -1;
  public totalChunks: number;
  public uploadedChunks: number = 0;
  public uploadingChunks: number = 0;
  public startOrCompleteRetries: number = 0;
  public uploadStatus: UploadFileStatus = UploadFileStatus.PENDING;

  constructor(
    uniqueID: number,
    identifier: string,
    uploadFileType: UploadFileType,
    file: File,
    chunkSize: number
  ) {
    this.uniqueID = uniqueID;
    this.totalChunks = Math.ceil(file.size / chunkSize);
    this.identifier = identifier;
    this.uploadFileType = uploadFileType;
    this.file = file;
  }
}

export default UploadFileInformation;
